import { createContext} from "react"
import { ALL_ANIMAL_INFO } from "./data";

function getRandomizedBoard(){
    let newBoard = new Array(16);
    let temp_copy = Array.from(ALL_ANIMAL_INFO)
    let temp_copy2 = Array.from(ALL_ANIMAL_INFO)
    let all_animal_info = temp_copy.concat(temp_copy2)
  
    while(all_animal_info.length > 0){
        let randomIdx = Math.floor(Math.random()*all_animal_info.length)
        let removedAnimal = all_animal_info.splice(randomIdx,1)
     
        newBoard.push(Object.assign({},removedAnimal[0]))
    }

    return newBoard;
}

export const MainContext = createContext()


const MainProvider = ({children}) => {
    return (<MainContext.Provider value={{getRandomizedBoard}}>
        {children}
    </MainContext.Provider>);
};

export default MainProvider;